


































































import { defineComponent, ref, computed, watch } from '@vue/composition-api';
import { PageHeader, PageBody, QrCode, Copyable } from '@nimiq/vue-components';
import { createRequestLink, CurrencyInfo, GeneralRequestLinkOptions, NimiqRequestLinkType } from '@nimiq/utils';
import { useSettingsStore } from '@/stores/Settings';
import AmountInput from '../../AmountInput.vue';
import AmountMenu from '../../AmountMenu.vue';
import FiatConvertedAmount from '../../FiatConvertedAmount.vue';
import { CryptoCurrency, FIAT_CURRENCIES_OFFERED } from '../../../lib/Constants';
import { useFiatStore } from '../../../stores/Fiat';

export default defineComponent({
    props: {
        address: {
            type: String,
            required: true,
        },
        currency: {
            type: String,
            required: true,
            validator: (currency: CryptoCurrency) => Object.values(CryptoCurrency).includes(currency),
        },
    },
    setup(props/* , context */) {
        const amount = ref(0);
        const message = ref('');
        const { btcUnit } = useSettingsStore();

        const requestLinkOptions = computed(() => ({
            type: props.currency === CryptoCurrency.NIM ? NimiqRequestLinkType.URI : undefined,
            amount: amount.value,
            currency: props.currency,
            message: message.value,
        } as GeneralRequestLinkOptions));

        const requestLink = computed(
            () => createRequestLink(props.address, requestLinkOptions.value),
        );

        const amountMenuOpened = ref(false);
        const activeCurrency = ref(props.currency);
        const fiatAmount = ref(0);

        const { state: fiat$, exchangeRates, currency: referenceCurrency } = useFiatStore();
        const otherFiatCurrencies = computed(() => FIAT_CURRENCIES_OFFERED.filter((fiat) => fiat !== fiat$.currency));

        const fiatCurrencyInfo = computed(() => {
            if (activeCurrency.value === CryptoCurrency.NIM || activeCurrency.value === CryptoCurrency.BTC) {
                return new CurrencyInfo(referenceCurrency.value);
            }
            return new CurrencyInfo(activeCurrency.value);
        });

        const fiatToCoinDecimalRatio = computed(() => 10 ** fiatCurrencyInfo.value.decimals
            / (props.currency === CryptoCurrency.NIM ? 1e5 : 1e8));

        watch(activeCurrency, (currency) => {
            if (currency === CryptoCurrency.NIM || currency === CryptoCurrency.BTC) {
                fiatAmount.value = 0;
                return;
            }

            // Fiat store already has all exchange rates for all supported fiat currencies
            // TODO: What to do when exchange rates are not yet populated?
            fiatAmount.value = amount.value
                * fiat$.exchangeRates[props.currency][currency]!
                * fiatToCoinDecimalRatio.value;
        });

        watch(() => {
            if (activeCurrency.value === CryptoCurrency.NIM || activeCurrency.value === CryptoCurrency.BTC) return;
            amount.value = Math.floor(
                fiatAmount.value
                / exchangeRates.value[props.currency][activeCurrency.value]!
                / fiatToCoinDecimalRatio.value);
        });

        return {
            origin: window.location.origin,
            amount,
            message,
            btcUnit,
            requestLink,
            amountMenuOpened,
            activeCurrency,
            fiatAmount,
            fiatCurrency: fiat$.currency,
            fiatCurrencyInfo,
            otherFiatCurrencies,
        };
    },
    components: {
        PageHeader,
        PageBody,
        QrCode,
        Copyable,
        AmountInput,
        AmountMenu,
        FiatConvertedAmount,
    },
});
